module.exports = __webpack_public_path__ + "static/media/vistara-tail.efa18c7f.png";